// 应用路由
const routers = [
  // 租户账户管理
  {
    path: "/tenantAccount",
    name: "租户账户管理",
    meta: { hidden: false, breadcrumb: [{ name: "租户账户管理" }] },
    component: () => import("@/views/sam/TenantAccount/index.vue"),
  },
  // 租户账户管理(查看财务流水)
  {
    path: "/financialStatements",
    name: "财务流水",
    meta: {
      // eslint-disable-next-line
      hidden: false, breadcrumb: [{ name: "租户账户管理", path: "/tenantAccount" },
      { name: "财务流水" },
      ],
    },
    component: () => import("@/views/sam/TenantAccount/financialStatements.vue"),
  },
  {
    path: "/tenantAccountSettlementRecord",
    name: "租户结算账单",
    meta: { hidden: false, breadcrumb: [{ name: "租户结算账单" }] },
    component: () => import("@/views/sam/TenantAccount/SettlementRecord.vue"),
  },
  {
    path: "/tenantAccountWithdrawalRecord",
    name: "触点提现记录",
    meta: { hidden: false, breadcrumb: [{ name: "触点提现记录" }] },
    component: () => import("@/views/sam/TenantAccount/WithdrawalRecord.vue"),
  },
  // 资金钱包
  {
    path: "/fundWallet",
    name: "资金钱包",
    meta: { hidden: false },
    component: () => import("@/views/sam/FundManagement/index.vue"),
  },
  // 余额预警
  {
    path: "/earlyWarning",
    name: "余额预警",
    meta: {
      // eslint-disable-next-line
      hidden: false, breadcrumb: [{ name: "资金管理" },
      { name: "资金钱包", path: "/fundWallet" },
      { name: "余额预警" },
      ],
    },
    component: () => import("@/views/sam/FundManagement/earlyWarning.vue"),
  },
  // 资金流水
  {
    path: "/capitalFlow",
    name: "资金流水",
    meta: {
      // eslint-disable-next-line
      hidden: true, title: "资金流水", breadcrumb: [{ name: "资金管理" },
      { name: "资金钱包", path: "/fundWallet" },
      { name: "资金流水" },
      ],
    },
    component: () => import("@/views/sam/FundManagement/capitalFlow.vue"),
  },
  // 冻结资金
  {
    path: "/freezeFunds",
    name: "冻结资金",
    meta: { hidden: false },
    component: () => import("@/views/sam/FundManagement/freezeFunds.vue"),
  },
  // 变更记录
  {
    path: "/changeRecord",
    name: "变更记录",
    meta: {
      // eslint-disable-next-line
      hidden: false, breadcrumb: [{ name: "资金管理" },
      { name: "冻结资金", path: "/freezeFunds" },
      { name: "变更记录" },
      ],
    },
    component: () => import("@/views/sam/FundManagement/changeRecord.vue"),
  },
  // 结算账单
  {
    path: "/settlementBill",
    name: "结算账单",
    meta: { hidden: false },
    component: () => import("@/views/sam/FundManagement/settlementBill.vue"),
  },
  // 查看详情
  {
    path: "/details",
    name: "查看详情",
    meta: {
      // eslint-disable-next-line
      hidden: false, breadcrumb: [{ name: "资金管理" },
      { name: "结算账单", path: "/settlementBill" },
      { name: "查看详情" },
      ],
    },
    component: () => import("@/views/sam/FundManagement/details.vue"),
  },
  // 触点提现
  {
    path: "/contactWithdrawal",
    name: "触点提现",
    meta: { hidden: false },
    component: () => import("@/views/sam/FundManagement/contactWithdrawal.vue"),
  },
];
export default routers;
